/* eslint-disable */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModalComponent } from '../base-modal.component';
import { latLng, tileLayer, MapOptions, marker, icon, PointExpression } from 'leaflet';
import { Coordinates } from 'types/reading-room.interface';

export const MAP_CENTER_LAT = 56.9677;
export const MAP_CENTER_LNG = 24.1056;
export const ICON_SIZE: PointExpression = [48, 43];
export const ICON_ANCHOR: PointExpression = [26, 40];

@Component({
  selector: 'app-map-modal',
  standalone: true,
  imports: [LeafletModule, TranslateModule],
  templateUrl: './map-modal.component.html',
  styleUrl: './map-modal.component.scss'
})
export class MapModalComponent extends BaseModalComponent implements OnInit {
  @Input() selectedCoordinates?: Coordinates;
  @Output() coordinatesSelected: EventEmitter<Coordinates> = new EventEmitter<Coordinates>();
  marker?: L.Marker<any>;
  options: MapOptions = {
    layers: [
      tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        maxZoom: 18,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
      })
    ],
    zoom: 8,
    center: latLng(MAP_CENTER_LAT, MAP_CENTER_LNG)
  };

  ngOnInit(): void {
    if (this.selectedCoordinates) {
      this.marker = marker([this.selectedCoordinates.lat, this.selectedCoordinates.lng], {
        icon: icon({
          iconSize: ICON_SIZE,
          iconAnchor: ICON_ANCHOR,
          iconUrl: 'assets/images/reading-room-marker.svg'
        })
      });
    }
  }

  onMapClick(event: L.LeafletMouseEvent): void {
    const { lat, lng } = event.latlng;

    this.marker = marker([lat, lng], {
      icon: icon({
        iconSize: ICON_SIZE,
        iconAnchor: ICON_ANCHOR,
        iconUrl: 'assets/images/reading-room-marker.svg'
      })
    });

    this.selectedCoordinates = { lat, lng };
  }

  handleSave(): void {
    this.coordinatesSelected.emit(this.selectedCoordinates);
    this.close();
  }
}
